import { computed } from 'vue';
import { useFlagEnabled } from '@/composables/featureFlags/useFlagEnabled';

export function useFeatureFlag() {
  const [loading, enabled] = useFlagEnabled('slack-app-only-signable');

  return {
    isEnabled: computed(() => !loading.value && enabled.value),
  };
}
